import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  ProIncreamentViewCountMutation,
  ProIncreamentViewCountMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';

export const PRO_INCREMENT_VIEW_COUNT = graphql(`
  mutation ProIncreamentViewCount($id: Int!) {
    incrementProViewCount(proId: $id)
  }
`);

export const useIncrementViewCount = () => {
  const [increment] = useMutation<
    ProIncreamentViewCountMutation,
    ProIncreamentViewCountMutationVariables
  >(PRO_INCREMENT_VIEW_COUNT);

  const incrementViewCount = useCallback(
    (id?: number) => {
      if (!id) {
        return;
      }
      increment({
        variables: {
          id,
        },
      });
    },
    [increment],
  );

  return {
    incrementViewCount,
  };
};
